import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HelpBlock } from 'react-bootstrap';
import { Field } from 'redux-form';
import masterField from '../../../../../components/search-form/master-field';
import renderField from './render-field';

class ActiviyThresholdField extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div>
        <Field
          name="full_automation_activity_threshold"
          component={renderField}
          disabled={this.props.disabled}
        />
        <HelpBlock>Minimum number of activities a contact must have, in the lookback period, to be automatically submitted. Only opportunity owner activities are considered when determining the activity count for a contact.</HelpBlock>
      </div>
    );
  }
}

ActiviyThresholdField.propTypes = {
  value: PropTypes.bool,
  disabled: PropTypes.bool,
  submitting: PropTypes.bool,
  onChange: PropTypes.func,
};
ActiviyThresholdField.defaultProps = {
  value: false,
  disabled: false,
  submitting: false,
};
export default masterField(ActiviyThresholdField);
